import { Badge } from './ui/Badge';
import { OVERSIGHT_BY_MODE, FLOW_STATUS_LABELS } from '../lib/catalog';
import type { Flow, Run, AgentFile, HumanOversightMode } from '../types';

export function FlowStatusBadge({ status }: { status: Flow['status'] }) {
  const tone = status === 'published' ? 'success' : status === 'draft' ? 'warning' : 'neutral';
  return <Badge tone={tone} dot>{FLOW_STATUS_LABELS[status]}</Badge>;
}

export function RunStatusBadge({ status }: { status: Run['status'] }) {
  const map: Record<Run['status'], { tone: 'success' | 'danger' | 'warning' | 'info'; label: string }> = {
    success: { tone: 'success', label: 'Sucesso' },
    error: { tone: 'danger', label: 'Erro' },
    running: { tone: 'info', label: 'Em andamento' },
    paused_for_human: { tone: 'warning', label: 'Aguardando humano' },
  };
  const { tone, label } = map[status];
  return <Badge tone={tone} dot>{label}</Badge>;
}

export function OversightBadge({ mode, size = 'md' }: { mode: HumanOversightMode; size?: 'sm' | 'md' }) {
  const def = OVERSIGHT_BY_MODE[mode];
  const Icon = def.icon;
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium"
      style={{ color: def.color, borderColor: `${def.color}33`, backgroundColor: `${def.color}14` }}
      title={def.description}
    >
      <Icon className={size === 'sm' ? 'h-3 w-3' : 'h-3.5 w-3.5'} />
      {def.label}
    </span>
  );
}

export function IndexStatusBadge({ status }: { status: AgentFile['indexStatus'] }) {
  const map: Record<AgentFile['indexStatus'], { tone: 'success' | 'warning' | 'danger' | 'info'; label: string }> = {
    ready: { tone: 'success', label: 'Pronto' },
    indexing: { tone: 'info', label: 'Indexando' },
    pending: { tone: 'warning', label: 'Pendente' },
    error: { tone: 'danger', label: 'Erro' },
  };
  const { tone, label } = map[status];
  return <Badge tone={tone} dot>{label}</Badge>;
}
